const localStorageStore = {};

localStorageStore.getToken = () => {
  return localStorage.token ?? "";
};

localStorageStore.setToken = (token) => {
  localStorage.setItem("token", token);
};

localStorageStore.setRole = (role) => {
  localStorage.setItem("Role", role);
};

localStorageStore.getRole = () => {
  return localStorage.Role ?? "";
};
localStorageStore.getAttending = () => {
  return localStorage.attending ?? "";
};
localStorageStore.setAttending = (value) => {
  localStorage.setItem("attending", value);
};
localStorageStore.setDefaultTemplate = (value) => {
  localStorage.setItem("template", value);
};
localStorageStore.getDefaultTemplate = (value) => {
  return localStorage.getItem("template") ?? "";
};

localStorageStore.resetDefaultTemplate = () => {
  localStorage.removeItem("template");
};

localStorageStore.getFilterValues = () => {
  return localStorage.getItem("valerion_filter_values") ?? "";
};

localStorageStore.setFilterValues = (value) => {
  localStorage.setItem("valerion_filter_values", value);
};

localStorageStore.getLoggedInUserId = () => {
  return localStorage.getItem("loginUserId") ?? "";
};

export default localStorageStore;
